import { type HTMLAttributes, type Ref } from 'react';
import { cn } from '@/lib/cn';

type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  ref?: Ref<HTMLDivElement>;
};

const WIDTHS: Record<NonNullable<ContainerProps['size']>, string> = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-6xl',
  xl: 'max-w-7xl',
};

export const Container = (props: ContainerProps) => {
  const { ref, className, size = 'xl', ...rest } = props;
  return (
    <div
      ref={ref}
      className={cn('mx-auto w-full min-w-0 px-3 sm:px-6', WIDTHS[size], className)}
      {...rest}
    />
  );
};
Container.displayName = 'Container';
